import React from 'react';
import BugsnagPerformance from '@bugsnag/browser-performance';
import Bugsnag, { NotifiableError } from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';

const apiKey = '12a0987b049016057c5dd02bc3ba8863';

const { hostname } = window.location;
const releaseStage =
  // eslint-disable-next-line no-nested-ternary
  hostname === 'localhost' ? 'development' : hostname.endsWith('claire.nowomed.com') ? 'staging' : 'production';

export const bugsnag = Bugsnag.start({
  apiKey,
  releaseStage,
  plugins: [new BugsnagPluginReact()],
});

export const BugsnagErrorBoundary = bugsnag.getPlugin('react')?.createErrorBoundary(React) ?? React.Fragment;

BugsnagPerformance.start({ apiKey });

export function handleError(error: unknown, metadata?: { [key: string]: any }) {
  if (metadata) {
    console.error(error, metadata);
  } else {
    console.error(error);
  }
  bugsnag.notify(error as NotifiableError, (e) => {
    e.severity = 'error';
    if (metadata) {
      e.addMetadata('metadata', metadata);
    }
  });
}

export function handleWarning(error: unknown, metadata?: { [key: string]: any }) {
  if (metadata) {
    console.warn(error, metadata);
  } else {
    console.error(error);
  }
  bugsnag.notify(error as NotifiableError, (e) => {
    e.severity = 'warning';
    if (metadata) {
      e.addMetadata('metadata', metadata);
    }
  });
}

export function handleInfo(error: unknown, metadata?: { [key: string]: any }) {
  if (metadata) {
    console.info(error, metadata);
  } else {
    console.error(error);
  }
  bugsnag.notify(error as NotifiableError, (e) => {
    e.severity = 'info';
    if (metadata) {
      e.addMetadata('metadata', metadata);
    }
  });
}
